import { useState } from "react";
import { Select, Table } from "antd";
import { useQuery } from "react-query";
import { getAudit } from "../../api/monitoring";

const ACTIONS = [
  ["", "All actions"],
  ["rule", "Rule changes"],
  ["settings", "Settings changes"],
  ["hold", "Hold decisions"],
  ["alert", "Alert actions"],
  ["case", "Case actions"],
  ["customer", "Customer rescans"],
];

const Audit = () => {
  const [page, setPage] = useState(1);
  const [action, setAction] = useState("");
  const { data, isFetching } = useQuery(["monitoring-audit", page, action], () =>
    getAudit({ page, limit: 50, ...(action && { action }) }),
  );
  return (
    <div className="bg-white rounded-lg p-5 space-y-3">
      <div className="flex justify-between items-center">
        <div className="text-[13px] text-[#00000080]">Every monitoring decision, who made it and when. Entries can't be edited.</div>
        <Select
          value={action}
          onChange={(v) => {
            setAction(v);
            setPage(1);
          }}
          className="w-[180px]"
          options={ACTIONS.map(([value, label]) => ({ value, label }))}
        />
      </div>
      <Table
        rowKey="_id"
        size="small"
        loading={isFetching}
        dataSource={data?.entries || []}
        pagination={{ current: page, pageSize: 50, total: data?.total || 0, onChange: setPage }}
        columns={[
          { title: "When", dataIndex: "at", key: "at", render: (v) => <span className="whitespace-nowrap">{new Date(v).toLocaleString()}</span> },
          { title: "Who", dataIndex: "actor", key: "actor" },
          { title: "Action", dataIndex: "action", key: "action", render: (v) => <span className="font-mono text-[12px]">{v}</span> },
          { title: "Target", key: "target", render: (_, e) => <span className="text-[12px]">{e.targetType} {e.targetId}</span> },
          {
            title: "Details",
            dataIndex: "details",
            key: "details",
            render: (v) => <pre className="text-[11px] whitespace-pre-wrap max-w-[420px] m-0">{v ? JSON.stringify(v, null, 1) : ""}</pre>,
          },
        ]}
      />
    </div>
  );
};

export default Audit;
